/** 只读后端 API（与现站 PHP 兼容） */
const json = async (url, opts = {}) => {
  const res = await fetch(url, {
    ...opts,
    headers: {
      Accept: "application/json",
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) throw new Error(`${url} → ${res.status}`);
  return res.json();
};

export function extractIpfsCid(url) {
  const s = String(url || "");
  const m =
    s.match(/\/ipfs\/([a-zA-Z0-9]+)/i) ||
    s.match(/^(?:ipfs:\/\/)?((?:bafy|bafk|Qm)[a-zA-Z0-9]+)/i);
  return m ? m[1] : "";
}

/** 优先同源代理（国内稳、有磁盘缓存）；失败再直连 Pinata */
export function thumbSrc(url) {
  const raw = String(url || "");
  const cid = extractIpfsCid(raw);
  if (!cid) return raw;
  return `/api/ipfs_img.php?cid=${encodeURIComponent(cid)}`;
}

/**
 * 站内媒体地址（金库封面 / 本地 images / IPFS）
 * 相对路径必须加前导 /，否则在 /deploy/:id 等嵌套路由下会解析到错误 URL。
 */
export function mediaSrc(url) {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw) || raw.startsWith("data:") || raw.startsWith("blob:")) {
    return thumbSrc(raw);
  }
  if (raw.startsWith("/")) return raw;
  return `/${raw.replace(/^\.\//, "")}`;
}

/** 缓存命中时 load 可能早于 Vue 绑定 → 用 ref 补一次 is-on */
export function bindThumbEl(el) {
  if (!el || el.tagName !== "IMG") return;
  const mark = () => {
    try {
      el.classList.add("is-on");
    } catch {
      /* ignore */
    }
  };
  if (el.complete && el.naturalWidth > 0) {
    mark();
    return;
  }
  el.addEventListener("load", mark, { once: true });
}

export function markThumbOn(e) {
  const el = e?.target;
  if (el) bindThumbEl(el);
}

/** 代理失败 → Pinata → 其它公共网关 */
export function onThumbError(e, originalUrl) {
  const el = e?.target;
  if (!el || !el.tagName) return;
  const step = Number(el.getAttribute("data-fb") || "0");
  const raw = String(originalUrl || el.getAttribute("data-raw") || "");
  const cid = extractIpfsCid(raw);
  if (!cid) {
    try {
      el.remove();
    } catch {
      /* ignore */
    }
    return;
  }
  const next = (src) => {
    el.classList.remove("is-on");
    el.src = src;
    // 换源后可能再次走缓存，补绑 load
    queueMicrotask(() => bindThumbEl(el));
  };
  if (step === 0) {
    el.setAttribute("data-fb", "1");
    next("https://flap.mypinata.cloud/ipfs/" + cid);
    return;
  }
  if (step === 1) {
    el.setAttribute("data-fb", "2");
    next("https://ipfs.io/ipfs/" + cid);
    return;
  }
  if (step === 2) {
    el.setAttribute("data-fb", "3");
    next("https://cloudflare-ipfs.com/ipfs/" + cid);
    return;
  }
  try {
    el.remove();
  } catch {
    /* ignore */
  }
}

export const api = {
  deploysList: () => json("api/deploys.php?view=list"),
  quotes: () => json("api/quotes.php?t=" + Date.now()),
  feed: (limit = 36) => json(`api/feed.php?limit=${limit}`),
  factoryShowcase: () => json("api/factory_showcase.php"),
  gainers: (limit = 200) => json(`api/gainers.php?limit=${limit}`),
};

export default api;
